
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Picnicspotnearchandrapur() {



  const cardData =
  {
    keyword: ' Picnic Spot Near Chandrapur',
    heading:  'Woodland Escape: Picnic Spot Near Chandrapur ',
    headingDescription: 'Woodland Escape Resort is one of the most beautiful picnic spots near Chandrapur, offering a peaceful escape into nature’s calm embrace. Surrounded by dense greenery, open lawns, and tranquil forest trails, the resort is perfect for families, school groups, or friends looking for a refreshing one-day getaway. Guests can enjoy outdoor games, nature walks, and relaxing picnic areas while savoring delicious local meals served with warm hospitality. The resort’s serene environment, clean surroundings, and cozy cottages make it a great destination to unwind and reconnect with nature. Whether you’re planning a quick break or a peaceful retreat, Woodland Escape Resort near Chandrapur promises a delightful blend of fun, relaxation, and natural charm.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Picnic Spot Near Chandrapur",
      "description": "Discover the best picnic spots near Chandrapur offering scenic beauty, peaceful surroundings, and family-friendly environments for a perfect outdoor escape. These locations feature lush greenery, riverside views, and open lawns ideal for group picnics, get-togethers, and nature walks. Spend your day enjoying recreational activities, delicious local snacks, and the natural charm that makes Chandrapur a top picnic destination in Maharashtra."
    },
    {
      "name": "Chandrapur Top Picnic Places",
      "description": "Explore the top picnic places in Chandrapur known for their scenic landscapes, greenery, and comfortable amenities. Whether you prefer forest trails, riverside spots, or garden retreats, these destinations provide an ideal setting for relaxation and family fun. Perfect for weekend outings, these top-rated picnic locations offer clean environments, parking facilities, and food options for a hassle-free experience."
    },
    {
      "name": "Chandrapur Family Picnic Spot",
      "description": "Plan a memorable family picnic in Chandrapur at beautiful parks, lakefronts, and nature-friendly resorts. Enjoy open lawns, safe play areas for kids, and shaded sitting zones where everyone can relax. These family picnic spots combine natural charm with modern conveniences, making them perfect for gatherings, celebrations, and day-long adventures with your loved ones."
    },
    {
      "name": "Chandrapur Nature Picnic Spot",
      "description": "Reconnect with nature at Chandrapur’s best picnic spots surrounded by forests, hills, and rivers. Ideal for nature lovers and photographers, these locations offer walking trails, birdwatching, and scenic viewpoints. Escape city life and immerse yourself in serene landscapes where you can enjoy peace, greenery, and the refreshing ambiance of natural surroundings."
    },
    {
      "name": "Affordable Picnic Spot Chandrapur",
      "description": "Enjoy a perfect day out without spending much at Chandrapur’s affordable picnic spots. These budget-friendly destinations offer great amenities like clean surroundings, rest areas, and basic facilities. Ideal for students, families, and large groups, these spots provide excellent value while ensuring fun, safety, and relaxation amid nature’s beauty."
    },
    {
      "name": "Chandrapur Weekend Picnic",
      "description": "Make your weekends more exciting with a quick getaway to Chandrapur’s weekend picnic spots. Enjoy time with friends and family in peaceful gardens, lakesides, and hill areas. These easily accessible destinations offer a refreshing break from the week’s hustle, allowing you to relax, play outdoor games, and enjoy simple pleasures in a natural environment."
    },
    {
      "name": "Chandrapur Riverside Picnic Spot",
      "description": "Relax by the riverside at Chandrapur’s beautiful picnic spots featuring serene water views, open seating areas, and boating options. Ideal for couples, families, and photographers, these locations provide the perfect backdrop for relaxation, fun, and outdoor dining. Enjoy the soothing sound of flowing water and make memories that last a lifetime."
    },
    {
      "name": "Chandrapur Garden Picnic Spot",
      "description": "Spend a delightful day at Chandrapur’s garden picnic spots surrounded by colorful flowers, manicured lawns, and shaded seating. Perfect for families with kids, these gardens provide peaceful surroundings for picnics, games, and photography. Bring your picnic basket, enjoy a leisurely meal, and soak in the beauty of nature’s greenery all around."
    },
    {
      "name": "Chandrapur Hill Picnic Spot",
      "description": "Take your picnic to new heights with Chandrapur’s stunning hill picnic spots. Offering panoramic views, cool breezes, and peaceful ambiance, these hilltop destinations are perfect for nature walks, trekking, and outdoor fun. Ideal for adventure seekers and photographers, these scenic locations promise an unforgettable day filled with relaxation and discovery."
    },
    {
      "name": "Chandrapur Kids Friendly Picnic Spot",
      "description": "Choose from Chandrapur’s best kid-friendly picnic spots that ensure safety, comfort, and entertainment for young ones. These locations include children’s play zones, open lawns, and shaded areas perfect for family gatherings. Parents can unwind while kids enjoy fun games, making it an ideal destination for wholesome family recreation."
    },
    {
      "name": "Chandrapur Scenic Picnic Spot",
      "description": "Capture breathtaking views and enjoy tranquil surroundings at Chandrapur’s scenic picnic spots. With lush greenery, sparkling rivers, and peaceful trails, these destinations offer plenty of photo opportunities and quiet corners for relaxation. Perfect for couples, families, and travelers seeking a serene escape into nature."
    },
    {
      "name": "Chandrapur Outdoor Picnic Spot",
      "description": "Experience open-air recreation at Chandrapur’s outdoor picnic spots with vast spaces for sports, barbeques, and fun activities. Ideal for large gatherings and groups, these locations offer picnic tables, lawns, and areas for adventure sports. Enjoy fresh air, sunshine, and the freedom to relax and play in nature’s lap."
    },
    {
      "name": "Chandrapur Picnic Spot Booking",
      "description": "Book your favorite picnic spot in Chandrapur online to ensure a smooth and enjoyable outing. With convenient booking options, you can secure your preferred location in advance, avoiding last-minute rushes. Choose spots that offer amenities like restrooms, parking, and food facilities for a complete outdoor experience."
    },
    {
      "name": "Chandrapur Picnic Tour Packages",
      "description": "Explore Chandrapur with curated picnic tour packages that include transport, meals, and sightseeing. These packages are ideal for families, schools, and groups looking for an organized day out without planning hassles. Experience the best of Chandrapur’s natural and cultural attractions in one fun-filled itinerary."
    },
    {
      "name": "Chandrapur Best Picnic Location",
      "description": "Visit the best picnic locations in Chandrapur that combine nature, comfort, and entertainment. From riversides to forest parks, these handpicked destinations offer the perfect atmosphere for relaxation, family time, and outdoor fun. Enjoy a memorable day surrounded by nature’s beauty, good food, and joyful company."
    }
  ],
  "tableData": [
    ["- Picnic Spot Near Chandrapur", "- Chandrapur Top Picnic Places"],
    ["- Chandrapur Family Picnic Spot", "- Chandrapur Nature Picnic Spot"],
    ["- Affordable Picnic Spot Chandrapur", "- Chandrapur Weekend Picnic"],
    ["- Chandrapur Riverside Picnic Spot", "- Chandrapur Garden Picnic Spot"],
    ["- Chandrapur Hill Picnic Spot", "- Chandrapur Kids Friendly Picnic Spot"],
    ["- Chandrapur Scenic Picnic Spot", "- Chandrapur Outdoor Picnic Spot"],
    ["- Chandrapur Picnic Spot Booking", "- Chandrapur Picnic Tour Packages"],
    ["- Chandrapur Best Picnic Location", ""]
  ],
  


whychoose: [
  {
    "WhyChooseheading": "Perfect Picnic Spot Near Chandrapur",
    "WhyChoosedescription": "Woodland Escape Resort is a serene and scenic picnic destination near Chandrapur. Surrounded by lush greenery and peaceful natural landscapes, it’s the perfect place to unwind and spend a joyful day with family or friends."
  },
  {
    "WhyChooseheading": "Tranquil Natural Setting",
    "WhyChoosedescription": "Nestled amidst trees and open green spaces, the resort offers a calm environment where you can relax, breathe in the fresh air, and reconnect with nature away from the city’s noise."
  },
  {
    "WhyChooseheading": "Ideal for Family and Group Outings",
    "WhyChoosedescription": "Whether it’s a family gathering, friends’ outing, or a group picnic, Woodland Escape Resort provides a safe and spacious area for everyone to play, relax, and make lasting memories together."
  },
  {
    "WhyChooseheading": "Fun and Leisure Activities",
    "WhyChoosedescription": "Enjoy a variety of activities such as nature walks, cycling, light adventure games, and pond-side relaxation. The resort caters to all age groups, offering both fun and relaxation in one place."
  },
  {
    "WhyChooseheading": "Comfortable Picnic Facilities",
    "WhyChoosedescription": "With shaded sit-outs, clean rest zones, and dedicated picnic areas, the resort ensures you enjoy your day comfortably. Everything is designed to make your outdoor experience stress-free and enjoyable."
  },
  {
    "WhyChooseheading": "Delicious Food and Refreshments",
    "WhyChoosedescription": "Treat yourself to freshly prepared local meals, snacks, and beverages. The resort offers a variety of food options to make your picnic day flavorful and satisfying."
  },
  {
    "WhyChooseheading": "Easily Accessible from Chandrapur",
    "WhyChoosedescription": "Located just a short drive from Chandrapur, Woodland Escape Resort is the ideal spot for a quick and convenient picnic. Spend more time enjoying nature and less time traveling."
  }
]



















  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a picnic spot near Chandrapur?",
    answer: "Woodland Escape Resort is one of the most peaceful and refreshing picnic spots near Chandrapur. Surrounded by greenery and natural beauty, it’s the perfect place to relax, play, and enjoy quality time with family or friends."
  },
  {
    question: "How far is Woodland Escape Resort from Chandrapur city?",
    answer: "The resort is located within a comfortable driving distance from Chandrapur, making it ideal for a quick day picnic or weekend getaway. Guests can easily reach by car and enjoy a full day of fun and relaxation."
  },
  {
    question: "What activities are available for picnic visitors at Woodland Escape Resort?",
    answer: "Visitors can enjoy nature walks, outdoor games, cycling, open lawns, and peaceful sitting areas. The resort offers a perfect mix of recreation and relaxation for all age groups."
  },
  {
    question: "Is Woodland Escape Resort suitable for families and groups visiting for a picnic?",
    answer: "Yes, the resort is completely family-friendly and group-friendly. Safe surroundings, clean spaces, and plenty of outdoor activities make it a great spot for picnics with loved ones."
  },
  {
    question: "Does Woodland Escape Resort provide food and refreshments for picnic guests?",
    answer: "Yes! The resort offers freshly prepared meals, snacks, and beverages. Picnic packages can include lunch and refreshments to make your visit hassle-free and enjoyable."
  },
  {
    question: "How can we book a picnic at Woodland Escape Resort near Chandrapur?",
    answer: "You can easily book your picnic by calling or sending a WhatsApp message to our reservations team, or by visiting the official website. Advance booking is recommended for weekends and holidays."
  }
];

const testimonials = [
  {
    name: "Mr. Ajay & Family, Chandrapur",
    text: "Our family had an amazing picnic at Woodland Escape Resort! The place is calm, green, and perfect for spending a day away from the city. Definitely one of the best picnic spots near Chandrapur."
  },
  {
    name: "Miss. Neha & Friends, Chandrapur",
    text: "We had a fun-filled picnic at Woodland Escape Resort! The food was tasty, the lawns were beautiful, and the environment was peaceful. Highly recommended for a day trip near Chandrapur!"
  }
];




















      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Picnic Spot Near Chandrapur",
  "image": "https://woodlandescape.com/assets/images/picnic-spot-chandrapur.jpg",
  "description": "Plan a perfect day out at Woodlandescape Resort, one of the best picnic spots near Chandrapur. Enjoy scenic nature, riverside views, outdoor activities, and family-friendly amenities for a memorable outing.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "198"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1499",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/picnic-spot-chandrapur"
  }
};





  return (
    <div>
<Helmet>
  <title>Picnic Spot Near Chandrapur | Scenic & Family-Friendly | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Enjoy a memorable day out at Woodlandescape Resort, one of the best picnic spots near Chandrapur. Scenic nature, riverside views, outdoor activities, and family-friendly amenities await for a perfect outing." 
  />
  <meta 
    name="keywords" 
    content="Picnic Spot Near Chandrapur, Chandrapur Top Picnic Places, Chandrapur Family Picnic Spot, Chandrapur Nature Picnic Spot, Affordable Picnic Spot Chandrapur, Chandrapur Weekend Picnic, Chandrapur Riverside Picnic Spot, Chandrapur Garden Picnic Spot, Chandrapur Hill Picnic Spot, Chandrapur Kids Friendly Picnic Spot, Chandrapur Scenic Picnic Spot, Chandrapur Outdoor Picnic Spot, Chandrapur Picnic Spot Booking, Chandrapur Picnic Tour Packages, Chandrapur Best Picnic Location" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/24.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Picnicspotnearchandrapur;